import API from "./axios";

export class BrandsService {
    constructor() {

    }
    brands(status:number): Promise<any> {
        return API.post(`api/index.php`, {"action":"getBrands","src":"dashboard","brandid":0,"categoryid":0,"status":status,"retrievalmode":"mysql"});
    }

    createBrand( data: any): Promise<any> {
      
        return API.post(`api/index.php`, { 'action': 'BrandDataAction', 'src': 'dashboard', retrievalmode: 'mysql',  'data': [data] });
    }

}